import { judgeDeviceType } from '@/utils/device'

window.collectEvent = window.collectEvent || (() => { })
const getUserId = () => localStorage.getItem("wwid");

/** 自定义埋点公共函数 */
export const customCollectEvent = (name, options = {}, isConfigWWID = true) => {

  const handleOptions = {
    ...options
  }

  window.collectEvent('config', {
    ww_device_platform: getDevicePlatform(),
    ww_device_platform_detail: getDevicePlatformDetail(),
  })

  if (isConfigWWID) {
    window.collectEvent('config', {
      wwid: getUserId() || '-1'
    })
  }

  window.collectEvent(name, handleOptions)

  // 区分原本的脏数据 - 数据分析用 2024.8.15 添加
  window.collectEvent(`${ name }_new`, handleOptions)

}

export function setCollectUserID(wwid = '') {
  wwid = wwid || getUserId()
  if (wwid) {
    window.collectEvent('config', {
      user_unique_id: wwid
    })
  }
  window.collectEvent('config', {
    wwid: wwid || '-1'
  })
}


/** 获取埋点的 ww_device_platform 值 */
export function getDevicePlatform() {
  switch (judgeDeviceType.source) {
    case 'app':
      return judgeDeviceType.isIOS ? 'ios-app' : 'android-app'
    case 'weapp':
    case 'tt':
      return 'mini'
    default:
      return 'web'
  }
}

/** 获取埋点的 ww_device_platform_detail 值 */
export function getDevicePlatformDetail() {
  // 第二个值
  let type2 = 'other'
  switch (judgeDeviceType.source) {
    case 'app':
      type2 = 'moyin'
      break;
    case 'weapp':
      type2 = 'wechat'
      break;
    case 'tt':
      type2 = 'tiktok'
      break;
    default:
      type2 = 'other'
      break;
  }
  // 汇总
  return `${judgeDeviceType.isIOS ? 'ios' : 'android'
    }-${type2
    }-${'web'
    }`
}

window.customCollectEvent = customCollectEvent;
window.setCollectUserID = setCollectUserID;
